import { render, staticRenderFns } from "./SmsLead.vue?vue&type=template&id=3d8f1307&"
import script from "./SmsLead.vue?vue&type=script&lang=js&"
export * from "./SmsLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports